function inferUnits(locale = {}) {
  const { code } = locale;
  const [_l, country] = code.split('-');
  if (country?.toLowerCase() === 'ca') {
    return 'km';
  }

  return 'mi';
}

export default inferUnits;
